<template>
  <el-tabs type="border-card">
    <el-tab-pane label="投放计划">
      <launch />
    </el-tab-pane>
    <el-tab-pane label="广告">
      <advertising />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Launch from '@/views/launchManagement/launch'
import Advertising from '@/views/launchManagement/advertising'
export default {
  name: 'LaunchTab',
  components: { Advertising, Launch }
}
</script>

<style scoped lang="less">
  /deep/ .el-tabs__content {
    padding: 0 !important;
  }
  /deep/ .el-tabs__item.is-active {
    color: #333333 !important;
  }
  /deep/ .el-tabs__item:hover {
    color: #333333 !important;
  }
</style>
